import { commonSharePcBtns } from '../loaders';
import { setWindowTemplates } from '../Templates';

(() => {
    setWindowTemplates('common-share-pc-btns', commonSharePcBtns);
})();
